/* eslint-disable react/no-children-prop */
import React from 'react';
import { Tooltip } from '@vds/tooltips';
import PropTypes from 'prop-types';

const VdsTooltip = (props) => {
  const { id, title, ariaLabel, children, containerId, renderAnchorElement,
    size, surface, closeButtonText, iconFillColor, disabled, className, content } = props;

  return (
    <Tooltip
      id={id}
      title={title}
      ariaLabel={ariaLabel}
      children={children}
      containerId={containerId}
      disabled={disabled}
      renderAnchorElement={renderAnchorElement}
      size={size}
      className={className}
      surface={surface}
      closeButtonText={closeButtonText}
      iconFillColor={iconFillColor}
    >
      {children || content}
    </Tooltip>
  );
};

VdsTooltip.defaultProps = {
  ariaLabel: 'More information',
  disabled: false,
  size: 'medium',
  surface: 'light',
  closeButtonText: 'Close',
  iconFillColor: 'primary',
};

VdsTooltip.propTypes = {
  ariaLabel: PropTypes.string,
  children: PropTypes.any,
  containerId: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  renderAnchorElement: PropTypes.func,
  size: PropTypes.oneOf(['medium', 'small']),
  title: PropTypes.string || PropTypes.array || PropTypes.node,
  content: PropTypes.string,
  className: PropTypes.any,
  surface: PropTypes.oneOf(['light', 'dark']),
  closeButtonText: PropTypes.string,
  iconFillColor: PropTypes.oneOf(['primary', 'secondary', 'brandHighlight']),
};

export default VdsTooltip;
